import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-20168_playbook-journey-for-learn'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
